import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core'
import { OidcStore } from '@core/store/oidc/oidc.store'
import { Heading } from '@shared/components/heading/heading'

@Component({
  selector: 'bo-logout',
  template: '<bo-heading titleText="MTR_TITLE_LOGOUT" />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Heading],
})
export class Logout implements OnInit {
  readonly #oidcStore = inject(OidcStore)

  ngOnInit() {
    this.#oidcStore.logOut()
  }
}
